import {Injectable} from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import {Observable} from 'rxjs';
import {HttpCallLog} from './error-types';
import {ApiTrackingBusService} from '@webmate-web-core/shared/services/api-tracking-bus.service';

@Injectable()
export class ApiTrackingInterceptor implements HttpInterceptor {

    constructor(private apiTrackingBus: ApiTrackingBusService){}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        this.apiTrackingBus.emit(new HttpCallLog(request.urlWithParams, request.headers, request.method));
        return next.handle(request);
    }
}
